import { uuid } from "@/utils";

/**
 * 标记页面的唯一id
 */
export const tabId = uuid();
